import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { TeamPurchaseOrderPhase, TeamSalesOrderPhase, Workspace, WorkspaceSalesOrderPhase } from '@/hooks/api/models';

/**
 * 2600. チーム発注フェーズ同期
 * [PUT] /workspaces/:identifier/teams/:team_id/sync_purchase_order_phases
 */
type Props = {
  identifier: string;
  team_id: number;
};
export const syncPurchaseOrderPhases = (props: Props): Promise<TeamPurchaseOrderPhase[]> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sync_purchase_order_phases`, props);
};

export const useSyncPurchaseOrderPhases = () => {
  return useMutation({
    mutationFn: syncPurchaseOrderPhases,
  });
};
